/* eslint-disable react/display-name */
import Loadable from '@loadable/component';
import { routes as routeConstants } from '../../global-stores/src/global/constants';

const LifestyleStrategyContainer = Loadable(
  () => import('./templates/LifestyleStrategyContainer/LifestyleStrategyContainer')
);
const routes = [
  {
    path: routeConstants.LIFESTYLE_STRATEGY,
    component: LifestyleStrategyContainer,
  },
];

export default routes;
